export default function(value, decimals) {
    if (typeof value === 'undefined' || value === null)
        return '';

    value = parseFloat(value);

    decimals = decimals || 0;
    var options = {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    };

    return value.toLocaleString(undefined, options);
}
